import {
  MEDIA_IMAGE_CONTENT_TYPES,
  MEDIA_VIDEO_CONTENT_TYPES,
  buildAcceptAttribute,
} from '@/constants/media';

export const SUPPORT_LIST_REFETCH_INTERVAL_MILLISECONDS = 20000;
export const SUPPORT_ACTIVE_TICKET_REFETCH_INTERVAL_MILLISECONDS = 5000;
export const SUPPORT_UNREAD_BADGE_MAXIMUM = 99;

export const SUPPORT_TICKET_STATUSES = [
  'open',
  'assigned',
  'in_progress',
  'waiting_on_practitioner',
  'resolved',
  'closed',
] as const;

export const SUPPORT_TICKET_CATEGORIES = [
  'technical_issue',
  'question',
  'billing',
  'feature_request',
  'account',
  'other',
] as const;

export const SUPPORT_TICKET_PRIORITIES = ['low', 'normal', 'high', 'urgent'] as const;

export const SUPPORT_PLATFORM_STATUS_TARGETS = [
  'in_progress',
  'waiting_on_practitioner',
  'resolved',
  'closed',
] as const;

export const SUPPORT_MEDIA_ALLOWED_CONTENT_TYPES = [
  ...MEDIA_IMAGE_CONTENT_TYPES,
  ...MEDIA_VIDEO_CONTENT_TYPES,
  'image/gif',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
];

export const SUPPORT_MEDIA_ACCEPT_ATTRIBUTE = buildAcceptAttribute(
  SUPPORT_MEDIA_ALLOWED_CONTENT_TYPES
);
